import makeSlice from '@web/slices/additionalOption/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload: {additionalOrderOptions, products}}) => {
            if (additionalOrderOptions) {
                const {inputOptions, selectOptions} = additionalOrderOptions
                state.enabled = true
                state.inputOptions = inputOptions
                state.selectOptions = selectOptions

                const options = [...selectOptions, ...inputOptions].map(({name, exposeOrder}) => ({
                    name,
                    exposeOrder,
                    value: '',
                }))

                state.selected = {
                    isParticularInput: false,
                    individuallyInput: options,
                    particularInputByItemId: products.reduce<Record<string, typeof options>>((acc, {items: [item]}) => {
                        if (item) {
                            acc[item.orderSheetItemId] = options
                        }
                        return acc
                    }, {}),
                }
            }
        })
    },
})

export default slice.reducer
